import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-425dee26"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "direct-debit" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item-secondary-title mb-2" }, "Direct debit", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item-content mb-3" }, " You must have full signing authority to set up this direct debit. If you don't, please select Online banking or Direct debit form from the options above. ", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item-secondary-title mb-3" }, "Bank account details", -1))
const _hoisted_5 = { class: "row m-0" }
const _hoisted_6 = { class: "text-input-small col-lg-auto col-md-auto col-sm-auto col-xs-12 px-0 mb-4 me-2" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item-label" }, "Bank account number", -1))
const _hoisted_8 = {
  key: 0,
  class: "mt-1 item-validation-error"
}
const _hoisted_9 = { class: "row m-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SelectInput = _resolveComponent("SelectInput")!
  const _component_TextInputSmall = _resolveComponent("TextInputSmall")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_SelectInput, {
        value: _ctx.enteredValues.bankName,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.enteredValues.bankName) = $event)),
        title: 'Bank name',
        options: _ctx.banks,
        class: "col-lg-auto col-md-auto col-sm-auto col-xs-12 px-0 mb-4 me-2",
        "validation-error": _ctx.readError('bankName')
      }, null, 8, ["value", "options", "validation-error"]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.enteredValues.bankAccountNumber) = $event)),
          class: _normalizeClass(["item-body ins-form-control ps-2", { 'validation-error': _ctx.readError('bankAccountNumber') }]),
          maxlength: "19",
          pattern: "[0-9]*",
          inputmode: "numeric",
          placeholder: "00 - 0000 - 0000000 - 000"
        }, null, 2), [
          [_vModelText, _ctx.enteredValues.bankAccountNumber]
        ]),
        (_ctx.readError('bankAccountNumber'))
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.readError("bankAccountNumber")), 1))
          : _createCommentVNode("", true)
      ]),
      _createVNode(_component_TextInputSmall, {
        value: _ctx.enteredValues.bankAccountName,
        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.enteredValues.bankAccountName) = $event)),
        placeholder: 'E.g. J L Smith',
        title: 'Bank account name',
        class: "px-0 mb-4 me-2",
        "validation-error": _ctx.readError('bankAccountName')
      }, null, 8, ["value", "placeholder", "validation-error"])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createVNode(_component_TextInputSmall, {
        value: _ctx.fullName,
        title: 'Full name',
        class: "px-0 mb-2 me-2",
        "is-disabled": true
      }, null, 8, ["value"]),
      _createVNode(_component_TextInputSmall, {
        value: _ctx.email,
        title: 'Email address',
        class: "px-0 mb-2 me-2",
        "is-disabled": true
      }, null, 8, ["value"])
    ])
  ]))
}